import { Action, createReducer, on } from '@ngrx/store';
import { ClearData } from '@shared/models/prospect-data-models.interface';

import * as LetterUploadActions from '../../actions/letter-upload/letter-upload.actions';
import { IFileMetaData } from '../document-upload/document-upload.reducer';

export interface ILetterUploadState {
  filesMetaData: IFileMetaData[];
  clearData: ClearData;
  vgHasLetter: boolean;
}

export const initialState: ILetterUploadState = {
  filesMetaData: [],
  clearData: {
    clearOutcome: '',
    uploadedFilename: '',
  },
  vgHasLetter: false,
};

const letterUploadReducer = createReducer(
  initialState,
  on(LetterUploadActions.updateLetterFilesMetaData, (state, props) => {
    return {
      ...state,
      filesMetaData: props.payload,
    };
  }),
  on(LetterUploadActions.updateLetterProspectClearDocuments, (state, props) => ({
    ...state,
    clearData: props.payload,
  })),
  on(LetterUploadActions.updateVgHasLetter, (state, props) => ({
    ...state,
    vgHasLetter: props.payload,
  })),
);

export function reducer(state: ILetterUploadState | undefined, action: Action) {
  return letterUploadReducer(state, action);
}

export const getHasClientUploadedFile = (state: ILetterUploadState) =>
  state.filesMetaData.length > 0;
